import { useEffect, useRef } from "react";
import { useEditorStore } from "@/store";

/**
 * Runs style validation on a debounced schedule whenever the style changes.
 */
export function useStyleValidation() {
  const styleVersion = useEditorStore((s) => s.styleVersion);
  const runValidation = useEditorStore((s) => s.runValidation);
  const timer = useRef<ReturnType<typeof setTimeout>>(undefined);

  useEffect(() => {
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      runValidation();
    }, 300);

    return () => clearTimeout(timer.current);
  }, [styleVersion, runValidation]);
}
